/**
 * Zustand store for AI sidebar state management.
 */

import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface AISidebarState {
  isOpen: boolean
  activeAction: string | null
  open: () => void
  close: () => void
  toggle: () => void
  setActiveAction: (actionId: string | null) => void
}

export const useAISidebarStore = create<AISidebarState>()(
  persist(
    (set) => ({
      isOpen: false,
      activeAction: null,

      open: () => set({ isOpen: true }),
      close: () => set({ isOpen: false, activeAction: null }),
      toggle: () =>
        set((state) => ({
          isOpen: !state.isOpen,
          activeAction: state.isOpen ? null : state.activeAction,
        })),
      setActiveAction: (actionId) => set({ activeAction: actionId }),
    }),
    {
      name: 'sage-ai-sidebar',
      partialize: (state) => ({ isOpen: state.isOpen }),
    }
  )
)
